/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'

export const Footer = () => {
  const  WEBSITE_URL  = "https://renewworkforce.com";


  return (
     <footer className="footer ">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3 className="heading-medium">Renew Workforce</h3>
            <p className="body-standard footer-description">
              Connecting exceptional talent with leading opportunities across specialized industries.
            </p>
          </div>
          <div className="footer-links">
            <div className="footer-column">
              <h4 className="body-standard footer-title">Services</h4>
              <ul className="footer-list">
                <li><a  className="footer-link">IT Staffing</a></li>
                <li><a  className="footer-link">Engineering</a></li>
                <li><a  className="footer-link">Pharmaceutical</a></li>
                <li><a  className="footer-link">Medical Device</a></li>
              </ul>
            </div>
            <div className="footer-column">
              <h4 className="body-standard footer-title">Company</h4>
              <ul className="footer-list">
                <li><a href={`${WEBSITE_URL}#about`} target='_blank' rel="noreferrer" className="footer-link"> About Us</a></li>
                <li><a href={`${WEBSITE_URL}#jobs`} target='_blank' rel="noreferrer" className="footer-link">Careers</a></li>
                <li><a href={`${WEBSITE_URL}#contact`} target='_blank' rel="noreferrer" className="footer-link">Contact</a></li>
                <li><a href={`${WEBSITE_URL}/#privacy-policy`} target='_blank' rel="noreferrer" className="footer-link">Privacy Policy</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="body-small">&copy; 2024 Renew Workforce. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}
